var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loadingOrg && !_vm.loadingPersons)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.org))]),_vm._l((_vm.contacts),function(p){return _c('div',{key:p.id},[_vm._v(_vm._s(p.fullName))])})],2):_c('loader',{attrs:{"size":14}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }